module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['reply-item', _vm.itemHide ? 'f-dn' : '']
  }, [(_vm.openBtnShow) ? _c('a', {
    staticClass: "open-btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.openReplyHandle
    }
  }, [_vm._v("\n\t\t展开" + _vm._s(_vm.count - 3) + "条回复"), _c('span', {
    staticClass: "icon-arrow"
  })]) : _vm._e(), _vm._v(" "), _c('reply-top-bar', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), _c('item-content', {
    attrs: {
      "item": _vm.item,
      "hide": _vm.itemHide
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c184e926!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment/reply-item.vue
// module id = 863
// module chunks = 2